import PropTypes from 'prop-types';
import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { getDocumentsUrl } from '../../../draft-transplant/utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentsPopoverEmptyState = () => /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
  image: "documents",
  title: "draftPlugins.documents.popover.zeroState.header",
  description: "draftPlugins.documents.popover.zeroState.description",
  buttonLabel: "draftPlugins.documents.popover.zeroState.button",
  buttonLink: getDocumentsUrl()
});
DocumentsPopoverEmptyState.propTypes = {
  portalId: PropTypes.number.isRequired
};
export default DocumentsPopoverEmptyState;